import { Button, Typography } from '@mui/material'
import { Buffer } from 'buffer'
import { RootStateOrAny, useSelector } from 'react-redux'
import { useInput } from '../../hooks/useInput'
import { unsubscribeUser } from '../../modules/unsubscribe'
import { useAppDispatch } from '../../store'
import FormContainer from '../Form/FormContainer'
import TextInput from '../Form/TextInput'
import Loader from '../Loader/Loader'
import Message from '../Message/Message'

interface Props {
  match: {
    params: {
      email: string
    }
  }
}

const Unsubscribe = ({ match }: Props) => {
  const dispatch = useAppDispatch()

  // Params is a base 64 encoded string, set value to decoded string
  const { value: email, bind: bindEmail } = useInput(
    Buffer.from(match.params.email, 'base64').toString()
  )

  const { loading, error, success } = useSelector(
    (state: RootStateOrAny) => state.unsubscribe
  )

  const handleClick = () => {
    dispatch(unsubscribeUser(String(email)))
  }

  return (
    <div className="login flex">
      <div
        className="bg-image"
        style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
      ></div>
      <FormContainer>
        <div style={{ minHeight: 'calc(100vh - 215px' }}>
          {loading && <Loader />}

          <Typography variant="h5" sx={{ mb: 4, fontWeight: 700 }}>
            Unsubscribe
          </Typography>
          <TextInput name="email" bindValue={bindEmail} disabled />
          <Typography sx={{ mt: 2 }}>
            We're sorry to hear from us anymore. Click the button below to
            unsubscribe.
          </Typography>

          <Button
            color="primary"
            variant="contained"
            onClick={handleClick}
            disabled={loading || success}
            sx={{ mt: 4, mb: 4 }}
          >
            Submit
          </Button>

          {error && <Message variant="error">Cannot find user.</Message>}
          {success && (
            <Message variant="success">
              You have been successfully unsubscribed.
            </Message>
          )}
        </div>
      </FormContainer>
    </div>
  )
}

export default Unsubscribe
